/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';

export default function DefaultTable({
  dataToShow,
  headerHeight,
  mainAlternatives,
  onSelect
}) {
  /**
   * Renderiza as linhas com as alternativas da pergunta cruzada.
   */
  function renderAlternativesRows(pergunta) {
    return pergunta.alternativas.map((alternativa) => (
      <tr key={alternativa.id}>
        <td className="row">{alternativa.enunciado}</td>
        <td className="respondentes resultadoNumerico">
          <span>{alternativa.resultado_numerico}</span>
        </td>
        <td className="respondentes resultadoPercentual">
          {`${alternativa.resultado_percentual}%`}
        </td>
        {renderCrossings(alternativa)}
      </tr>
    ));
  }

  /**
   * Renderiza os cruzamentos entre a alternativa cruzada
   * e as alternativas da pergunta principal.
   */
  function renderCrossings(alternativa) {
    return mainAlternatives.map((item) => {
      const cruzamento = alternativa.cruzamentos?.[item.id];
      return (
        <td
          key={item.id}
          className={`resultado-cruzamento ${
            cruzamento?.marcacao?.is_checked ? 'selecionado' : ''
          }`}
          onClick={() => onSelect(cruzamento)}
          title={`Equivale a ${cruzamento?.resultado_numerico || ''} resposta(s)`}
        >
          <span>{`${cruzamento?.resultado_percentual || 0}%`}</span>
        </td>
      );
    });
  }

  return (
    <>
      {dataToShow.perguntas_principais[0].perguntas_cruzadas.map((pergunta) => (
        <tbody key={pergunta.id}>
          <tr>
            <th
              colSpan={mainAlternatives.length + 4}
              style={{ top: headerHeight }}
            >
              <span className="pergunta-cruzada-wrapper">{pergunta.enunciado}</span>
            </th>
          </tr>
          {renderAlternativesRows(pergunta)}
        </tbody>
      ))}
    </>
  );
}